import React from 'react';
import { useNavigate } from 'react-router-dom';
import LOGO from '../assets/LOGO.png';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer className="relative bg-dark-900 text-white overflow-hidden">
            {/* Arka plan büyük metin */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
                <h1 className="text-8xl md:text-9xl lg:text-[12rem] xl:text-[15rem] font-black text-dark-800 opacity-10 select-none whitespace-nowrap">
                    DijiVite
                </h1>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-8 lg:gap-12">
                    {/* Sayfalar */}
                    <div className="lg:col-span-1 text-center md:text-left">
                        <h3 className="text-white font-semibold mb-4">Sayfalar</h3>
                        <ul className="space-y-3">
                            <li>
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('hizmetlerimiz');
                                        if (element) {
                                            element.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start'
                                            });
                                        } else {
                                            window.location.href = '/#hizmetlerimiz';
                                        }
                                    }}
                                    className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm cursor-pointer"
                                >
                                    Hizmetlerimiz
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        navigate('/calismalarimiz');
                                    }}
                                    className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm cursor-pointer"
                                >
                                    Çalışmalarımız
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('neden-biz');
                                        if (element) {
                                            element.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start'
                                            });
                                        } else {
                                            window.location.href = '/#neden-biz';
                                        }
                                    }}
                                    className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm cursor-pointer"
                                >
                                    Neden Biz ?
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('iletisim');
                                        if (element) {
                                            element.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start'
                                            });
                                        } else {
                                            window.location.href = '/#iletisim';
                                        }
                                    }}
                                    className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm cursor-pointer"
                                >
                                    İletişim
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Sosyal Medya */}
                    <div className="lg:col-span-1 text-center md:text-left">
                        <h3 className="text-white font-semibold mb-4">Sosyal Medya</h3>
                        <ul className="space-y-3">

                            <li>
                                <a href="https://www.instagram.com/dijivite/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    Instagram
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Yasal */}
                    <div className="lg:col-span-1 text-center md:text-left">
                        <h3 className="text-white font-semibold mb-4">Yasal</h3>
                        <ul className="space-y-3">
                            <li>
                                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    Gizlilik Politikası
                                </a>
                            </li>
                            <li>
                                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    Kullanım Şartları
                                </a>
                            </li>
                            <li>
                                <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    Çerez Politikası
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* İletişim */}
                    <div className="lg:col-span-1 text-center md:text-left">
                        <h3 className="text-white font-semibold mb-4">İletişim</h3>
                        <ul className="space-y-3">
                            <li>
                                <a href="tel:05444643487" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    Hemen Arayın
                                </a>
                            </li>
                            <li>
                                <a href="mailto:dijivite@outlook.com" className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm">
                                    E-posta Gönder
                                </a>
                            </li>
                            <li>
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('iletisim');
                                        if (element) {
                                            element.scrollIntoView({
                                                behavior: 'smooth',
                                                block: 'start'
                                            });
                                        } else {
                                            window.location.href = '/#iletisim';
                                        }
                                    }}
                                    className="text-gray-400 hover:text-primary-400 transition-colors duration-300 text-sm cursor-pointer"
                                >
                                    İletişim Formu
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Logo ve Copyright */}
                    <div className="col-span-2 md:col-span-1 lg:col-span-1 order-last md:order-first text-center md:text-left">
                        <div className="flex items-center justify-center md:justify-start space-x-3 mb-6">
                            <div className="w-10 h-10 rounded-xl overflow-hidden flex items-center justify-center">
                                <img src={LOGO} alt="DijiVite Logo" className="w-full h-full object-contain" />
                            </div>
                            <span className="text-xl font-bold text-white">DijiVite</span>
                        </div>
                        <p className="text-gray-400 text-sm leading-relaxed mb-6">
                            © copyright DijiVite 2025. Tüm hakları saklıdır.
                        </p>
                    </div>
                </div>

                {/* Alt çizgi ve ek bilgiler */}
                <div className="border-t border-dark-800 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="flex items-center space-x-6">
                            <span className="text-gray-400 text-sm">📞 0544 464 34 87</span>
                            <span className="text-gray-400 text-sm">✉️  dijivite@outlook.com</span>
                        </div>
                        <div className="flex items-center space-x-4">

                            <a href="https://www.instagram.com/dijivite/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                                </svg>
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;